export function DayButton(props: {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onDoubleClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  day: number;
}) {
  return (
    <button
      type="button"
      className="flex min-w-7 cursor-pointer items-center justify-center rounded-sm border-0 bg-transparent px-1 py-0.5 text-sm font-semibold hover:bg-slate-100 disabled:pointer-events-none disabled:text-gray-300"
      onClick={props.onClick}
      onDoubleClick={props.onDoubleClick}
      disabled={props.disabled}
    >
      {props.day}
    </button>
  );
}
